






















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import VenueDisplay from '@ui/Venue/VenueDisplay'
import PricingTable from '@ui/Event/PricingTable'
import UpdatePricingModelTriggerModal from '@triggers/Event/UpdatePricingModelTriggerModal'

settings =
  name: 'VenueShow'

  resources:
    venue:
      resourceName: 'venue'
      slug: 'venues/:venueId'

  components: {
    LoadingIndicator,
    VenueDisplay,
    PricingTable,
    UpdatePricingModelTriggerModal,
  }

  vue:
    data: ->
      modal:
        show: true

    computed:
      actionsForPricingModel: ->
        hiUpdatePricingModelTrigger: @hiUpdatePricingModelTrigger
        hiRemoveSpecialPricingTrigger: @hiRemoveSpecialPricingTrigger

    methods:
      hiNavToEditStep: (step) ->
        params = { venueId: @venue.id }
        query = { step }
        @$router.push { name: 'VenueEditPage', params, query }

      hiUpdatePricingModelTrigger: (pricingModel, pricing) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, pricing }
        @$refs.updatePricingModelTrigger.fire payloadOptions, modalOptions
      hiRemoveSpecialPricingTrigger: (pricingModel) ->
        @triggerResource 'venue', 'update_pricing_model', { pricing_model: pricingModel }
      onVenueUpdatePricingModel: (data, response) ->
        @$refs.updatePricingModelTrigger.close()
        @fetch 'venue'

export default VueOptions.vue settings
